import { getAuthAxiosBackend } from "../../helpers/axios"

class VolunteerServices{

    get(id){
        return getAuthAxiosBackend().get('volunteers/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('volunteers', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('volunteers/' + id)
    }
}

export default new VolunteerServices()